import { atom } from "jotai";

type StorePackageModalPage = "DETAIL" | "PURCHASE" | "SUCCESS" | "AUTH";

export type StorePackageModalState = {
  page: StorePackageModalPage;
  memberPackageId?: string;
  orderId?: string;
};

export const StorePackageModalStateAtom = atom<StorePackageModalState>({
  page: "DETAIL",
});

export const memberPackageIdAtom = atom(
  (get) => get(StorePackageModalStateAtom).memberPackageId
);

export const orderIdAtom = atom(
  (get) => get(StorePackageModalStateAtom).orderId
);

export const currentPageAtom = atom(
  (get) => get(StorePackageModalStateAtom).page
);

export const goToPageAtom = atom(
  null,
  (
    _get,
    set,
    {
      page,
      memberPackageId,
      orderId,
    }: {
      page: StorePackageModalPage;
      memberPackageId?: string;
      orderId?: string;
    }
  ) => {
    set(StorePackageModalStateAtom, { page, memberPackageId, orderId });
  }
);
